<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-26 10:31:29
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 13:20:13
 -->
<template>
  <div class="rightPart">
    <div class="right-top">
      <div class="title">累计监测碰撞事件</div>
      <div class="eventNum">{{eventCumulativeData.eventTotal}}</div>
      <div class="protectMileage">安全守护里程：<span class="value">{{eventCumulativeData.mileageTotal}}</span> km</div>
      <div class="addMileage">本月新增里程数：<span class="value">{{eventCumulativeData.mileageMonth}}</span> km</div>
      <div class="compare">
        <div class="item">
          同比 <span :class="eventCumulativeData.yearOnYear >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{eventCumulativeData.yearOnYear}}%
        </div>
        <div class="item">
          环比 <span :class="eventCumulativeData.monthOnMonth >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{eventCumulativeData.monthOnMonth}}%
        </div>
      </div>
    </div>
    <div class="right-bottom">
      <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">事件通知</span>
      </div>
      <div class="content">
        <div class="itemContainer" v-if="eventNoticeList.length">
          <div class="item" v-for="(item, index) in eventNoticeList" :key="index">
            <el-tooltip class="describe" effect="light" :content="item.content" placement="top">
              <span class="describe">{{item.content}}</span>
            </el-tooltip>
            <span class="time">{{item.eventTime}}</span>
          </div>
          <div class="loadMore" @click="loadMore" v-if="pageNo < pages">加载更多</div>
        </div>
        <div class="noData" v-else>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'rightPart',
  components: {
  },
  data () {
    return {
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      eventCumulativeData: {},
      eventNoticeList: [],
    }
  },
  methods: {
    /**
     * @description                   获取累计监测碰撞事件数据
     * @return {undefied}             无返回值
     */
    getEventCumulativeData () {
      this.$http.get('/rest/screen/hlpz/right-top/summary')
        .then(res => {
          if (res.code === 0) {
            console.log(res.data)
            this.eventCumulativeData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取事件通知数据
     * @return {undefied}             无返回值
     */
    getEventNoticeData () {
      this.$http.get('/rest/screen/hlpz/event/page', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then(res => {
          if (res.code === 0) {
            let list = res.data.list
            list.map(item => {
              item.eventTime = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date(item.eventTime))
            })
            this.eventNoticeList = this.eventNoticeList.concat(list)
            this.pageNo = parseFloat(res.data.pageNo)
            this.total = parseFloat(res.data.total)
            this.pages = Math.ceil(parseFloat(res.data.total) / this.pageSize)
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   加载更多
     * @return {undefied}             无返回值
     */
    loadMore () {
      this.pageNo = this.pageNo + 1
      this.getEventNoticeData()
    },
  },
  created () {
    this.getEventCumulativeData()
    this.getEventNoticeData()
  },
}
</script>

<style lang="less" scoped>
  .rightPart {
    width: 100%;
    height: 100%;
    .right-top {
      width: 100%;
      height: 40%;
      >div {
        text-align: center;
      }
      .title {
        font-size: 1.5vh;
        color: #fff;
      }
      .eventNum {
        font-size: 6vh;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 2vh rgb(5, 239, 252);
        line-height: 10vh;
      }
      .protectMileage {
        font-size: 1.7vh;
        color: #00fcf0;
        line-height: 4vh;
        .value {
          font-size: 2vh;
        }
      }
      .addMileage {
        font-size: 1.7vh;
        color: #00fcf0;
        line-height: 4vh;
        .value {
          font-size: 2vh;
        }
      }
      .compare {
        line-height: 5vh;
        .item {
          display: inline-block;
          font-size: 1.4vh;
          color: #fff;
          margin-right: 2%;
          .el-icon-top {
            color: #d92626;
            font-weight: bold;
            font-size: 1.8vh;
          }
          .el-icon-bottom {
            color: #16c840;
            font-weight: bold;
            font-size: 1.8vh;
          }
        }
      }
    }
    .right-bottom {
      height: 60%;
      .titleHeader {
        width: 100%;
        height: 4vh;
        background: url('/static/img/layout/titleHeaderBg.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        >img {
          height: 100%;
          margin-right: 20px;
        }
        .titleName {
          font-family: SourceHanSansCN-Bold;
          font-size: 1.5vh;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #05dbe3;
        }
      }
      .content {
        width: 100%;
        height: 60%;
        padding-top: 2%;
        .itemContainer {
          width: 100%;
          height: 100%;
          overflow-y: scroll;
          .item {
            font-size: 1.4vh;
            line-height: 3vh;
            >span {
              display: inline-block;
              vertical-align: middle;
            }
            .status {
              width: 1.3vh;
              height: 1.3vh;
              border-radius: 50%;
              margin-right: 10px;
            }
            .describe {
              width: 60%;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              color: #d6d6d7;
            }
            .time {
              color: #2a969e;
            }
          }
          .loadMore {
            font-size: 1.5vh;
            cursor: pointer;
            text-align: center;
            color: #51afee;
          }
        }
        .noData {
          text-align: center;
          color: rgb(209, 197, 197);
          font-size: 1.6vh;
          line-height: 10vh;
        }
      }
    }
  }
</style>
